export function adjustImageSrc(originalSrc: string) {
  let src = originalSrc;
  if (src.includes("ccli-cdn.s3.amazonaws.com")) {
    src = src.replace(
      "https://ccli-cdn.s3.amazonaws.com",
      "https://cdn.ccli.com",
    );
  }
  if (src.includes("ccli-cdn.s3.us-east-1.amazonaws.com")) {
    src = src.replace(
      "https://ccli-cdn.s3.us-east-1.amazonaws.com",
      "https://cdn.ccli.com",
    );
  }

  return src;
}
